import * as React from 'react';
import DescriptionWrapper from './common/DescriptionWrapper';
import { RightArrowIcon } from './common/Icons';
import { NameRequirementManager }  from './common/requirementManagers/NameRequirementManager';
import {
    LowercaseLettersNumbersHyphensValidator,
    StartEndValidator,
    StringLengthValidator
} from '../services/nameValidation';
import { DOMAIN_MIN_ALLOWED_SYMBOLS, TOTAL_DOM_FS_ALLOWED_SYMBOLS, FILESPACE_MIN_ALLOWED_SYMBOLS } from '../utils/constants';
import { DescriptionWrapperProperties } from './common/DescriptionWrapper';
import { Message } from './common/Message';
import { Domain } from 'fs-api-client';
import { DomainInjectorProperties } from './hocs/DomainInjector';
import FlowManager from './common/FlowManager';

export interface DomainActionProperties extends DomainInjectorProperties {
    workspaceName: string;
    computedMatch: any;
}

interface DomainActionState {
    workspaceName: string;
    errorMessage: string;
    isError: boolean;
    isAwaitingRequest: boolean;
}

abstract class DomainAction extends React.Component<DomainActionProperties, DomainActionState> {
    private requirementManager: NameRequirementManager = new NameRequirementManager();
    private flowManager: FlowManager;

    constructor(props: any) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
        this.handleUserInputChanged = this.handleUserInputChanged.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.canContinue = this.canContinue.bind(this);

        this.setValidators();

        this.flowManager = new FlowManager(this.canContinue, this.onSubmit);
        this.flowManager.registerListeners();

        this.state = {
            workspaceName: props.workspaceName ? props.workspaceName : '',
            errorMessage: '',
            isError: false,
            isAwaitingRequest: false
        };
    }

    componentDidMount() {
        if (this.props.domain) {
            this.onDomainLoaded(this.props.domain);
        }
    }

    componentWillUnmount() {
        this.flowManager.unregisterListeners();
    }

    render() {
        let form = (
                <div className="col-12 col-lg-6 col-xl-6 offset-lg-1 d-flex align-items-center domain">
                    <form>
                        {this.getError()}
                        <div className="float-label-control nolabel large row">
                            <input autoFocus={true} value={this.state.workspaceName} type="text" className="form-control" name="Domain name" id="domain-name" onChange={this.handleUserInputChanged} />
                            <label htmlFor="domain-name">Domain name</label>
                        </div>
                        {this.requirementManager.getRequirements(this.state.workspaceName)}
                        <button type="button" disabled={!this.requirementManager.requirementsAreMet() || this.state.isError || this.state.isAwaitingRequest} className="btn step-btn float-right" onClick={this.onSubmit}>
                            <span>Next</span>
                            <RightArrowIcon width="13px" height="13px" />
                        </button>
                    </form>
                </div>
            ),
            descriptions = this.getDescriptions();

        return (
            <DescriptionWrapper
                {...descriptions}
            >
                {form}
            </DescriptionWrapper>
        );
    }

    protected abstract onDomainLoaded(domain: Domain): void;
    protected abstract getDescriptions(): DescriptionWrapperProperties;
    protected abstract onDomainSubmit(workspaceName: string): void;

    private canContinue(): boolean {
        return this.requirementManager.requirementsAreMet() && !this.state.isError && !this.state.isAwaitingRequest;
    }

    private submitDomain() {
        this.setState(
            { isAwaitingRequest: true },
            () => { this.onDomainSubmit(this.state.workspaceName); }
        );
    }

    private getError(): JSX.Element | null {
        if (!this.state.errorMessage) {
            return null;
        }

        return <Message message={this.state.errorMessage} />;
    }

    private onSubmit() {
        this.submitDomain();
    }

    private setValidators(): void {
        this.requirementManager.setValidators([
            new LowercaseLettersNumbersHyphensValidator(),
            new StartEndValidator(),
            new StringLengthValidator(
                DOMAIN_MIN_ALLOWED_SYMBOLS,
                TOTAL_DOM_FS_ALLOWED_SYMBOLS - FILESPACE_MIN_ALLOWED_SYMBOLS
            )
        ]);
    }

    private handleUserInputChanged(e: any): void {
        this.setState({
            workspaceName: e.target.value
        });
    }
}

export default DomainAction;



// WEBPACK FOOTER //
// ./src/webportal/components/DomainAction.tsx